import React, { Component } from 'react'
import { connect } from 'react-redux'
import { dataType } from '@/constants/data-type'

import '@/companys/fubon/assets/styles/components/market/market-cn.scss'

import DataTable from '@/components/DataTable/DataTable'
import MarketIndex from '@/components/MarketIndex/MarketIndex'
import { Comparator, utilsFunction } from '@/helpers/functions'

import { stockActions } from '@/actions/trading/stock.action'

class Market_CN extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeData_sh: [],
      activeData_sz: [],
      gainersData_sh: [],
      gainersData_sz: [],
      ColumnDefs: [
        {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'symbol',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SYMBOL,
          minWidth: 120
        },
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'stockName',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.common_price,
          colId: 'common_price',
          field: 'price',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 90
        },
        {
          headerName: props.language.common_change,
          colId: 'common_change',
          field: 'change',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          bindingColor: true,
          dataType: dataType.PERCENT_BASED,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_turnover_rate,
          colId: 'common_turnover_rate',
          field: 'rate',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.PERCENT_BASED,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_turnover,
          colId: 'common_turnover',
          field: 'turnover',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_bid,
          colId: 'common_bid',
          field: 'bid',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_ask,
          colId: 'common_ask',
          field: 'ask',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_volume,
          colId: 'common_volume',
          field: 'volume',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth: 90
        },
        {
          headerName: props.language.common_open,
          colId: 'common_open',
          field: 'open',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.market_quote_prev_close,
          colId: 'market_quote_prev_close',
          field: 'close',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_high,
          colId: 'common_high',
          field: 'high',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_low,
          colId: 'common_low',
          field: 'low',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        }
      ].filter(Boolean),
      isWatchList: false,
      reSendActiveStock: false,
      charts: [
        { exchangeID: "SH", key: "1" },
        { exchangeID: "SH", key: "300" },
      ]
    }
    if (props.innerRef) {
      props.innerRef(this)
    }
  }
  render() {
    const { language } = this.props
    const { ColumnDefs, activeData_sh, activeData_sz, gainersData_sh, gainersData_sz, charts } = this.state
    return (
      <div className='market_cn'>
        <div className='cn_left'>
          <div className='left_top'>
            <div className='title'>{language.market_index_chart}</div>
            <MarketIndex data={charts} innerRef={e => (this.chartsRef = e)} />
          </div>
          <div className='most_top'>
            <div className='title'>{language.market_sh_turnover_ranking}</div>
            <DataTable showPagination={false} columnDefs={ColumnDefs} data={activeData_sh} innerRef={e => (this.activeRef_sh = e)}></DataTable>
          </div>
          <div className='most_bottom'>
            <div className='title'>{language.market_sz_turnover_ranking}</div>
            <DataTable showPagination={false} columnDefs={ColumnDefs} data={activeData_sz} innerRef={e => (this.activeRef_sz = e)}></DataTable>
          </div>
        </div>
        <div className='cn_right'>
          <div className='right_top'>
            <div className='title'>{language.market_sh_gainers}</div>
            <DataTable showPagination={false} columnDefs={ColumnDefs} data={gainersData_sh} innerRef={e => (this.GainersRef_sh = e)}></DataTable>
          </div>
          <div className='right_bottom'>
            <div className='title'>{language.market_sz_gainers}</div>
            <DataTable showPagination={false} columnDefs={ColumnDefs} data={gainersData_sz} innerRef={e => (this.GainersRef_sz = e)}></DataTable>
          </div>
        </div>
      </div>
    )
  }
  componentDidMount() {
    const { currentTradingAccount, token, mdsToken } = this.props
    if (currentTradingAccount && token && mdsToken) {
      this.getMostActiveStocks_SH()
      this.getMostActiveStocks_SZ()
      this.getGainers_SH()
      this.getGainers_SZ()
    }
  }

  componentDidUpdate(preProps) {
    const { currentTradingAccount, isNeedRefresh, language, mdsToken } = this.props
    if (JSON.stringify(currentTradingAccount) == '{}' && preProps.currentTradingAccount !== currentTradingAccount) {
      this.getMostActiveStocks_SH()
      this.getMostActiveStocks_SZ()
      this.getGainers_SH()
      this.getGainers_SZ()
    }
    if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
      this.getMostActiveStocks_SH()
      this.getMostActiveStocks_SZ()
      this.getGainers_SH()
      this.getGainers_SZ()
    }
    if (language && preProps.language !== language) {
      this.getMostActiveStocks_SH()
      this.getMostActiveStocks_SZ()
      this.getGainers_SH()
      this.getGainers_SZ()
    }
    if (preProps.mdsToken != mdsToken && mdsToken) {
      this.getMostActiveStocks_SH()
      this.getMostActiveStocks_SZ()
      this.getGainers_SH()
      this.getGainers_SZ()
    }
  }

  updateCharts() {
    this.chartsRef.updateCharts()
  }

  InterfaceRequest(params, savedata, callback) {
    const { language, mdsToken } = this.props
    const data = []
    this.props.getTopRank(params, quest => {
      if (quest.rtnCode) {
        this.setState({ [savedata]: [] })
        callback()
        return
      }
      for (let i = 0; i < 20; i++) {
        const sample = ['symbol', 'stockName', 'price', 'change', 'bid', 'ask', 'volume', 'rate', 'open', 'close', 'high', 'low', 'turnover'].reduce(
          (prev, next) => ((prev[next] = '-'), prev),
          {}
        )
        const deepSample = JSON.parse(JSON.stringify(sample))
        const dparams = { symbols: [{ exchangeID: quest.elements[i]?.exchangeID, key: quest.elements[i]?.code }], sessID: mdsToken }
        this.props.getDetailPriceInfo(dparams, quetores => {
          let rq = quest.elements[i]
          if (quetores) {
            const twoNewRowData = JSON.parse(JSON.stringify(this.state[savedata]))
            const deepSample = twoNewRowData[i]
            for (let i = 0; i < 4; i++) {
              if (rq.code.length < 5) {
                rq.code = '0' + rq.code
              }
            }
            rq.exchangeID = rq.exchangeID + '.'
            deepSample.symbol = rq.exchangeID + rq.code
            const lang = language.lang
            if (lang === 'zh_TW') {
              deepSample.stockName = rq.tcName
            } else if (lang === 'zh_CN') {
              deepSample.stockName = rq.scName
            } else {
              deepSample.stockName = rq.name
            }
            deepSample.price = quetores.last
            deepSample.change = `${utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)} (${utilsFunction.datatableFormatPercent(
              ((quetores.last - quetores.prev) / quetores.prev) * 100
            )})`
            deepSample.bid = quetores.bids?.[0]?.price
            deepSample.ask = quetores.asks?.[0]?.price
            deepSample.vol = quetores.vol
            deepSample.rate = quetores.turnoverRate ? utilsFunction.formatPercent(quetores.turnoverRate) : '-'
            deepSample.open = quetores.turnoverRateopen
            deepSample.close = quetores.prev
            deepSample.high = quetores.high
            deepSample.low = quetores.low
            deepSample.turnover = quetores.turnover
            this.setState({ [savedata]: twoNewRowData })
          }
        })
        data.push(deepSample)
      }

      this.setState({ [savedata]: data })
      typeof callback === 'function' && callback()
    })
  }
  
  getMostActiveStocks_SH = () => {
    this.activeRef_sh.toggleLoadingOverlay(true)
    this.setState({ activeData_sh: null })
    const { mdsToken } = this.props
    const params = {
      symbols: [{ exchangeID: 'SH', key: 'OrinaryShare-Turnover' }],
      sessID: mdsToken
    }
    this.InterfaceRequest(params, 'activeData_sh', () => {
      this.activeRef_sh.toggleLoadingOverlay(false)
    })
  }

  getMostActiveStocks_SZ = () => {
    this.activeRef_sz.toggleLoadingOverlay(true)
    this.setState({ activeData_sz: null })
    const { mdsToken } = this.props
    const params = {
      symbols: [{ exchangeID: 'SZ', key: 'OrinaryShare-Turnover' }],
      sessID: mdsToken
    }
    this.InterfaceRequest(params, 'activeData_sz', () => {
      this.activeRef_sz.toggleLoadingOverlay(false)
    })
  }

  getGainers_SH = () => {
    this.GainersRef_sh.toggleLoadingOverlay(true)
    this.setState({ gainersData_sh: null })
    const { mdsToken } = this.props
    const params = {
      symbols: [{ exchangeID: 'SH', key: 'OrinaryShare-NetGainPercent' }],
      sessID: mdsToken
    }
    this.InterfaceRequest(params, 'gainersData_sh', () => {
      this.GainersRef_sh.toggleLoadingOverlay(false)
    })
  }

  getGainers_SZ = () => {
    this.GainersRef_sz.toggleLoadingOverlay(true)
    this.setState({ gainersData_sz: null })
    const { mdsToken } = this.props
    const params = {
      symbols: [{ exchangeID: 'SZ', key: 'OrinaryShare-NetGainPercent' }],
      sessID: mdsToken
    }
    this.InterfaceRequest(params, 'gainersData_sz', () => {
      this.GainersRef_sz.toggleLoadingOverlay(false)
    })
  }

}

export default connect(
  state => ({
    language: state.app.language,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    markets: [{ label: state.app.language.market_all, value: '' }, ...state.trade.markets],
    isNeedRefresh: state.refresh.orderTable,
    token: state.auth.token,
    theme: state.app.theme,
    mdsToken: state.trade.mdsToken
  }),
  dispatch => ({
    getTopRank: (p, c) => stockActions.getTopRankAction(p, c),
    getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c))
  })
)(Market_CN)
